export default __webpack_public_path__ + "fonts/AdobeClean-Regular.woff";